import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M7.636.92c-.205 0-.427 0-.614.025-.22.03-.5.105-.735.34a1.239 1.239 0 0 0-.342.736c-.025.187-.025.408-.025.613v1.427c0 .205 0 .427.024.614.03.22.105.5.341.736.22.22.479.3.69.334v1.199a3.5 3.5 0 0 0-2.317 2.835 5.588 5.588 0 0 0-.031.748v9.356c0 .41 0 .854.05 1.228.059.439.21 1 .682 1.47.472.473 1.032.624 1.47.683.375.05.819.05 1.229.05h7.884c.41 0 .854 0 1.228-.05.439-.059.999-.21 1.47-.682.472-.472.624-1.032.683-1.47.05-.375.05-.819.05-1.229v-9.356c0-.25 0-.51-.032-.748a3.5 3.5 0 0 0-2.317-2.835V5.745c.21-.034.468-.115.688-.334.236-.235.311-.516.341-.735.025-.187.025-.409.025-.614V2.636a4.72 4.72 0 0 0-.024-.614c-.03-.22-.105-.5-.34-.736a1.239 1.239 0 0 0-.736-.341c-.188-.026-.41-.025-.615-.025H7.636ZM7.42 2.67l.001-.25h9.157v1.607l-.001.249-.249.001H7.67l-.25-.001V2.67Zm8.104 3.476H8.476v2.099a.005.005 0 0 1-.004.004H8.47c-.319 0-.478 0-.612.019A2 2 0 0 0 6.145 9.98c-.018.133-.018.293-.018.612v9.221c0 .943 0 1.414.293 1.707.292.293.764.293 1.707.293h7.746c.943 0 1.414 0 1.707-.293.293-.293.293-.764.293-1.707v-9.221c0-.32 0-.479-.018-.612a2 2 0 0 0-1.713-1.713c-.134-.019-.294-.019-.613-.019h-.001a.005.005 0 0 1-.004-.004V6.146Z",
  "clip-rule": "evenodd"
}, null, -1), v = /* @__PURE__ */ c("path", { d: "M13.25 13.914v-2.582h-2.5v2.582H8.168v2.5h2.582v2.582h2.5v-2.582h2.582v-2.5h-2.583Z" }, null, -1), l = [
  n,
  v
];
function h(a, d) {
  return e(), t("svg", o, [...l]);
}
const s = { render: h };
export {
  s as default,
  h as render
};
